import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { ShopProductCard } from "../shop/ShopProductCard";
import { Reveal } from "../Reveal";

// Heena's Signature Stack — featured pieces from the catalogue.
export const SignatureStack = ({ products = [] }) => {
  const list = products.slice(0, 4);
  if (list.length === 0) return null;

  return (
    <section className="bg-brand-cream py-20 sm:py-28 lg:py-32" data-testid="signature-stack-section">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="grid items-center gap-12 lg:grid-cols-12 lg:gap-16">
          <Reveal className="lg:col-span-4">
            <p className="flex items-center gap-3 text-[11px] font-semibold uppercase tracking-[0.3em] text-brand-gold">
              <span className="h-px w-8 bg-brand-gold/60" aria-hidden="true" />
              Styled for Heena
            </p>
            <h2 className="mt-5 font-serif text-4xl font-medium leading-[1.08] tracking-tight text-brand-charcoal sm:text-5xl text-balance">
              Heena's Signature Stack
            </h2>
            <p className="mt-5 max-w-sm text-base leading-relaxed text-brand-stone">
              Beauty in every layer — the exact pieces our muse reaches for, curated into one luminous stack.
            </p>
            <Link
              to="/shop?category=premium"
              data-testid="signature-stack-cta"
              className="group mt-9 inline-flex items-center gap-2 border-b border-brand-gold/60 pb-1 text-[11px] font-semibold uppercase tracking-[0.22em] text-brand-gold transition-colors hover:border-brand-gold hover:text-brand-gold-hover"
            >
              Shop the stack
              <ArrowRight className="h-3.5 w-3.5 transition-transform duration-300 group-hover:translate-x-1" />
            </Link>
          </Reveal>
          <div className="grid grid-cols-2 gap-x-4 gap-y-9 sm:gap-6 lg:col-span-8 lg:grid-cols-4 lg:gap-6" data-testid="signature-stack-grid">
            {list.map((p, i) => (
              <Reveal key={p.id} delay={i * 0.1} className={i % 2 === 1 ? "lg:mt-10" : ""}>
                <ShopProductCard product={p} />
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
